import React, { useContext, useState, Fragment, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Forms } from '../../components/backgrounds/Forms'
import { Primary } from '../../components/buttons/Primary'
import { Steps, titles } from '../../components/buttons/Steps'
import Numeral from 'react-numeral'
import {
    clausulas,
    cartas,
    consultas
} from '../../components/legal/Content'
import { FirmaE } from '../../components/legal/Firma';
import { ProgressLinear } from '../../components/progress/progressLinear';
import { CreditUserContext } from '../../context/CreditUser/CreditUserContext';
import { FormOneContext } from '../../context/FormOne/FormOneContext';
import { FormTwoContext } from '../../context/FormTwo/FormTwoContext';
import { AuthContext } from '../../context/Auth/AuthContext';
import { HttpRequest } from '../../services/httpRequest';
import { FunnelService } from '../../services/funnel/funnel.service';
import { validateSessionAndJwtToken } from '../../utils/validateTokenSession';
import { returnToSignin } from '../../utils/returnToSign';


export function PagarePage() {

    const navigate = useNavigate();
    const { state } = useLocation();
    const { creditUser } = useContext(CreditUserContext);
    const { formOne } = useContext(FormOneContext);
    const { formTwo } = useContext(FormTwoContext);
    const { mail, phone } = useContext(AuthContext);

    const [viewProgress, setViewProgress] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [userDatas, setUserDatas] = useState([]);
    const [features, setFeatures] = useState([]);

    const handleProgress = (isView) => {
        setViewProgress(isView)
    }

    const loadCreditPendingSignature = async () => {
        try {
            const data = await HttpRequest.getCreditUserPendingSignature(localStorage.getItem('doc'));
            return data?.message?.info;
        } catch (error) {
            console.log(error);
        }
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        handleProgress(true);

        let data = {
            doc: creditUser.documento || state.doc,
            phone: phone
        }

        try {
            const responseService = await HttpRequest.aceptarPagare(data);

            if (responseService.error) {
                handleProgress(false);
                alert(responseService.message);
            }
            handleProgress(false);
            return navigate("/firma", { state: { doc: creditUser ? creditUser.documento : state.doc, isRenovateCredit: state ? state.isRenovateCredit : false } })
        } catch (error) {
            handleProgress(false);
            alert(error);
        }
    }

    const handleAddTimeline = async (idOperation, creditId) => {
        try {
            let payloadTimeline = {
                name: "Pagaré",
                description: "Pagaré de crédito",
                pathView: "/pagare",
                error: {
                    hasError: false,
                    errorMessage: ""
                },
                success: {
                    hasSuccess: true,
                    successMessage: "Ok"
                },
                styles: {
                    TimelineOppositeContent: {
                        sx: { m: "auto 0" },
                        align: "right",
                        variant: "body2",
                        color: "text.secondary",
                        style: { fontFamily: "GT Walsheim Pro", fontWeight: "lighter" }
                    },
                    TimelineDot: {
                        color: "primary"
                    },
                    TimelineContent: {
                        Typography: {
                            variant: "h6",
                            component: "span"
                        },
                        sx: { py: "12px", px: 2 }
                    },
                    icon: {
                        name: "CiViewTable",
                        size: "1.5rem"
                    }
                }
            };
            if (idOperation) {
                let { message } = await FunnelService.addTimelineByOperationId(idOperation, payloadTimeline)
                return message;
            } else if (creditId) {
                let { message } = await FunnelService.addTimelineByCreditId(creditId, payloadTimeline)
                return message;
            } else {
                return 'IdOperation or creditId is null.'
            }
        } catch (error) {
            return error;
        }
    }


    useEffect(() => {

        const loadCreditsUserPendingSignature = async () => {
            let credit = await loadCreditPendingSignature();
            return credit;
        }

        const validSessionAndTokenJwt = async () => {
            try {
                let isValidToken = await validateSessionAndJwtToken();
                return isValidToken;
            } catch (error) {
                return false;
            }
        };

        validSessionAndTokenJwt()
            .then(async (isValidToken) => {
                if (isValidToken) {
                    //Agregar timeline a funnel
                        let idOperation = localStorage.getItem('idOperation');
                        if (idOperation) {
                            handleAddTimeline(idOperation, null)
                                .then((message) => console.log(message))
                                .catch(e => console.log(e))
                        } else {
                            handleAddTimeline(null, localStorage.getItem('credit_id'))
                                .then((message) => console.log(message))
                                .catch(e => console.log(e))
                        }
                    let infoCredit = await loadCreditsUserPendingSignature();
                    let userDatas = [

                        { title: "Nombre completo:", value: `${formOne.firstname} ${formOne.secondname} ${formOne.firstlastname} ${formOne.secondlastname}` },
                        { title: "Documento:", number: creditUser.documento || state.doc },
                        {
                            title: "Dirección de residencia",
                            value: `${formOne.cityAddress}, ${formOne.depAddress}`,
                        },
                        { title: "Correo electrónico", value: mail },
                        { title: "Celular", value: phone },
                        { title: "Banco", value: formTwo.bankAccount },
                        { title: "Tipo de cuenta", value: formTwo.typeBankAccount },
                        { title: "Número de cuenta", value: formTwo.accountNumber },

                    ];

                    let features = [
                        { title: "PAGARÉ No.", value: state?.credit_id || localStorage.getItem('credit_id') || infoCredit.credit_id },
                        { title: "Valor", value: "____________" },
                        { title: "Fecha de vencimiento", value: "____________" },
                    ];
                    setUserDatas(userDatas);
                    setFeatures(features);
                    localStorage.setItem('credit_id', creditUser?.credit_id || state?.credit_id || infoCredit.credit_id);
                    setIsLoading(false);
                    return;
                } else {
                    returnToSignin(navigate);
                }
            })
            .catch((e) => {
                console.log(e);
                returnToSignin(navigate);
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) {
        return (
            <Fragment>
                <div className='bg-purpleLight h-screen'>
                    <Steps
                        estado1='complete'
                        estado2='complete'
                        estado3='complete'
                        estado4='current'
                    />
                    <Forms
                        title={titles[3].name}
                        description={'Cargando la información.'}
                        form={
                            <form action="#" method="POST" onSubmit={handleSubmit}>
                                <div className='shadow-lg overflow-hidden rounded-md'>
                                    <div className="px-4 py-5 bg-white sm:p-6">
                                        <div className='my-8'>


                                        </div>
                                    </div>
                                </div>
                            </form>
                        }
                    />
                </div>
            </Fragment>
        )

    }

    return (
        <div className='bg-purpleLight h-full'>
            <Steps
                estado1='complete'
                estado2='complete'
                estado3='complete'
                estado4='current'
            />

            <Forms
                title={titles[3].name}
                description={'Lee con atención el pagaré de tu crédito y si estás de acuerdo, presiona "Aceptar pagaré".'}
                form={
                    <form action="#" method="POST" onSubmit={handleSubmit} id='pagare-pdf'>
                        <div className='shadow-lg overflow-hidden rounded-md' >
                            <div className="px-4 py-5 bg-white sm:p-6">
                                <div className='overflow-y-scroll h-96'>
                                    <div className='uppercase font-bold'>
                                        <div className='my-4'>
                                            {features.map((feature, idx) => (
                                                <div key={idx} className='grid grid-cols-5'>
                                                    <div className='col-span-2'>
                                                        <h2 className=''>{feature.title}</h2>
                                                    </div>
                                                    <div className='col-span-3 ml-2'>
                                                        <h2>{feature.value}</h2>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className='mt-6'>
                                        <p>
                                            <span>{userDatas[0].value}</span> identificado/a con cédula de ciudadanía No.<Numeral className='mx-1' format={'0,0'} value={userDatas[1].number} />
                                            obrando en la calidad de EL DEUDOR, por medio del presente PAGARÉ hago constar:
                                        </p>
                                    </div>

                                    <div className='my-6'>
                                        {clausulas.map((clausula, idx) => (
                                            <p key={idx} className='mt-4'>
                                                <span className='font-bold uppercase'> {clausula.title} </span>
                                                {clausula.description}
                                            </p>
                                        ))}
                                    </div>

                                    <FirmaE />

                                    <div>
                                        <div className='text-center uppercase font-bold'>
                                            <h2 className='my-4'>Carta de instrucciones</h2>
                                        </div>
                                        <div>
                                            <div className='mb-2'>
                                                {userDatas[0].value}, identificado/a con cédula de ciudadanía No.<Numeral className='mx-1' format={'0,0'} value={userDatas[1].number} /> quien en adelante me denominaré EL DEUDOR, me permito manifestar que autorizo en forma irrevocable a GRUPO EMPRESARIAL ANAV S.A.S., quien en adelante se denominará Galilea, o a su cesionario o a quien en el futuro represente sus derechos u ostente la calidad de ACREEDOR de los dineros que llegue a adeudar a Galilea en virtud de la utilización del cupo de crédito rotativo que me fue aprobado, para llenar sin previo aviso el pagaré a la orden con espacios en blanco que he suscrito a favor de Galilea, conforme a las siguientes instrucciones:
                                            </div>
                                            {cartas.map((carta, idx) => (
                                                <p key={idx} className='mt-4'>
                                                    <span className='font-bold uppercase'> {carta.title} </span>
                                                    {carta.description}
                                                </p>
                                            ))}
                                        </div>
                                    </div>

                                    <FirmaE />

                                    <div>
                                        <div className='text-center uppercase font-bold'>
                                            <h2 className='my-4'>AUTORIZACIÓN PARA LA CONSULTA, REPORTE Y PROCESAMIENTO DE DATOS CREDITICIOS, FINANCIEROS, COMERCIALES, DE SERVICIOS Y DE TERCEROS EN LAS CENTRALES DE INFORMACIÓN FINANCIERA</h2>
                                        </div>
                                        <div>
                                            <div className='mb-2'>
                                                {userDatas[0].value}, identificado/a con cédula de ciudadanía No.<Numeral className='mx-1' format={'0,0'} value={userDatas[1].number} /> obrando en la calidad de EL DEUDOR en mi calidad de titular de información, actuando libre y voluntariamente autorizo de manera expresa e irrevocable a GRUPO EMPRESARIAL ANAV S.A.S. - Galilea, o a quien represente sus derechos u ostente en el futuro a cualquier título la calidad de acreedor, a consultar, solicitar, suministrar, reportar, procesar y divulgar toda la información que se refiera a mi comportamiento crediticio, financiero y comercial a las Centrales de Información Financiera que administra la Asociación Bancaria y de entidades Financieras de Colombia o a quien represente sus derechos.
                                            </div>
                                            {consultas.map((consulta, idx) => (
                                                <p key={idx} className='mt-4'>
                                                    {consulta}
                                                </p>
                                            ))}
                                        </div>
                                    </div>

                                    <FirmaE />

                                </div>
                                <div className="flex px-4 py-6 md:flex md:justify-end bg-white text-right sm:px-6">
                                    <div className='md:w-56'>
                                        {
                                            viewProgress ?
                                                <Fragment>
                                                    <ProgressLinear></ProgressLinear>
                                                    <p style={{ fontSize: 13 }}>Estamos generando tu código, por favor espera...</p>
                                                </Fragment>

                                                :
                                                <Primary text='Aceptar pagaré.' />
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                }
            />
        </div>
    )
}



